var _style, _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#31CB9E;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.1,150l99.4,56.9c2.5,1.5,5.7,0.7,7.2-1.8c0.5-0.8,0.8-1.8,0.7-2.7V97.5c0-2.9-2.3-5.2-5.1-5.3 c-1,0-2,0.3-2.8,0.8L136.1,150z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.4,67.8l-67.9-50c-2.4-1.8-5.8-1.4-7.6,1c-0.4,0.6-0.7,1.2-0.9,1.9L132.1,132l100.6-55.6 c2.5-1.3,3.4-4.3,2.2-6.7C234.6,68.9,234,68.3,233.4,67.8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.3,282.1l68-50c2.3-1.6,2.9-4.8,1.2-7.1c-0.5-0.7-1.1-1.2-1.8-1.6l-100.7-55.6l24.8,111.3 c0.7,2.9,3.6,4.7,6.5,4C164.1,282.9,164.8,282.6,165.3,282.1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.3,147.9l25.8-120.8c0.5-2.8-1.3-5.5-4-6c-1.4-0.3-2.8,0-3.9,0.8L62,72.7c-3.4,2.6-5.4,6.6-5.4,10.9v128.8 c-0.1,4.3,1.9,8.5,5.4,11.1l65.9,50.6c2.3,1.6,5.5,1,7.1-1.3c0.8-1.1,1.1-2.6,0.8-3.9L110.3,147.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnc);
export default __webpack_public_path__ + "static/media/KNC.996d5b328b0fc0b253191db985827359.svg";
export { ForwardRef as ReactComponent };